import { useCallback } from 'react';
import { useStateWithCallback } from './useStateWithCallback';

export const useStateWithObserver = (initializer, observerCb) => {
  const [state, setState] = useStateWithCallback(initializer);

  const setStateWithObserver = useCallback((setter) => {
    setState(setter, observerCb);
  }, []);

  return [state, setStateWithObserver];
};
